import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import type { ImportGuide } from './dataImportApi.ts';

// Values past this many are counted rather than listed.
const MAX_OPTIONS = 12;

// Every column Forge reads for this kind of record and what it does with it,
// with the tenant's own values where a column has to name one.
export const ImportColumnGuide = ({ guide }: { guide: ImportGuide }) => (
  <Accordion
    disableGutters
    elevation={0}
    sx={{ border: 1, borderColor: 'divider', borderRadius: 1, '&::before': { display: 'none' } }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="subtitle2">What each column does</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ pt: 0 }}>
      {guide.fields.map((field) => {
        const shown = field.options?.slice(0, MAX_OPTIONS) ?? [];
        const more = (field.options?.length ?? 0) - shown.length;
        return (
          <Box
            key={field.key}
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '170px 1fr' },
              gap: { xs: 0.25, sm: 2 },
              py: 1,
              borderTop: 1,
              borderColor: 'divider'
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {field.label}
              {field.alternative ? (
                <Typography component="span" variant="caption" color="text.secondary">
                  {' '}
                  (not in the template)
                </Typography>
              ) : null}
            </Typography>
            <Box>
              <Typography variant="body2" color="text.secondary">
                {field.description}
              </Typography>
              {field.options ? (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  {shown.length
                    ? `Yours: ${shown.join(', ')}${more > 0 ? `, and ${more} more` : ''}`
                    : 'You have none set up yet.'}
                </Typography>
              ) : null}
            </Box>
          </Box>
        );
      })}
    </AccordionDetails>
  </Accordion>
);
